<div class="page d-flex flex-column" *ngIf="form || errorMessage">
    <div class="toolbar">
        <div class="nuvei-app-container d-flex justify-content-between align-items-center h-100">
            <div class="d-flex align-items-center h-100">
                <img class="logo" src="../../../assets/logo.svg" routerLink="/lobby">
                <h4 class="business-name" *ngIf="form?.dbaForm?.businessName">{{ form.dbaForm!.businessName }}</h4>
            </div>
            <img class="logo" src="../../../assets/nuvei_logo.svg">
        </div>
    </div>
    <div class="flex-fill d-flex flex-column justify-content-center align-items-center gap--32" *ngIf="errorMessage">
        <h2 class="message">{{ errorMessage }}</h2>
        <button mat-flat-button color="primary" (click)="close()">Close</button>
    </div>

    <div class="nuvei-app-container flex-fill d-flex flex-column" *ngIf="!errorMessage">
        <div class="step-summary">
            <p *ngIf="!form.signatures.guarantor?.submitted">Please take a moment to carefully review all the details in the document.</p>
            <p *ngIf="form.signatures.guarantor?.submitted">Thank you! {{ form.signatures.owner!.signerName }} has been notified for further action.</p>
        </div>

        <div class="sections flex-fill" [class.extended]="extendDocument">
            <div class="document-container">
                <iframe [src]="documentUrl" class="flex-fill w-100" frameborder="0"></iframe>
            </div>

            <div class="divider">
                <app-icon src="chevron" class="se-icon-button expand-main-section-button" [class.extended]="extendDocument" (click)="extendDocument = !extendDocument"></app-icon>
            </div>

            <div>
                <div class="info">
                    <ng-container *ngIf="form.status === 'created'">
                        <p *ngIf="form.signatures.guarantor?.submitted">
                            This document will be automatically <strong>deleted</strong> 15 minutes after the application is submitted by {{ form.signatures.owner!.signerName }}.
                            You can <strong>download</strong> it before then by clicking the <app-icon src="download" class="text-icon"></app-icon> button above the document.
                        </p>
                        <p *ngIf="!form.signatures.guarantor?.submitted">
                            You will be able to download the document once you submit your signature.
                            The document will be deleted automatically 15 minutes after the application will be submitted by {{ form.signatures.owner!.signerName }}.
                        </p>
                    </ng-container>
                    <ng-container *ngIf="form.status === 'pending'">
                        <p *ngIf="downloadAvailable">
                            This document will be deleted in: <strong>{{ downloadTimer$ | async }}</strong><br>
                            Until then, you can <strong>download</strong> this file by pressing the <app-icon src="download" class="text-icon"></app-icon> button above the document.
                        </p>
                        <p *ngIf="!downloadAvailable">
                            This document is no longer available ion our system.<br>
                            You can <strong>download</strong> this file as long as you don't refresh the page by pressing the <app-icon src="download" class="text-icon"></app-icon> button above the document.
                        </p>
                    </ng-container>
                </div>
                <div class="actions">
                    <ng-container *ngIf="!form.signatures.guarantor?.submitted">
                        <div class="signature">
                            <div class="form-checkbox w-100">
                                <mat-checkbox [formControl]="submitCheckboxControl" color="primary" (change)="requestApproval($event)"></mat-checkbox>
                                <p style="text-wrap: balance; text-wrap: pretty;">I reviewed the document, confirm that all the information provided is valid and I agree to sign it digitally.</p>
                            </div>
                            <div [class]="'signature-frame ' + (!form.signatures.guarantor ? 'open' : 'signed')" [class.disabled]="signatureApproval === undefined"
                                 (click)="openSignatureModal()"
                            >
                                <div class="add-signature" *ngIf="!form.signatures.guarantor && !waitingForSignatureApproval">Add signature</div>
                                <mat-progress-spinner mode="indeterminate" diameter="24" *ngIf="waitingForSignatureApproval"></mat-progress-spinner>
                                <img *ngIf="form.signatures.guarantor" [src]="form.signatures.guarantor.downloadUrl" alt="signature">
                            </div>
                            <div class="signer" *ngIf="!form.signatures?.guarantor">
                                {{ userName }}
                            </div>
                            <div class="signer" *ngIf="form.signatures.guarantor">
                                Signed by:&nbsp;{{ form.signatures.guarantor.signerName }}, &nbsp;{{ form.signatures.guarantor.timestamp | date: 'dd MMM, YYYY' }}
                            </div>
                        </div>
                        <loader-button style="width: 100%; max-height: 44px"
                                       [loading]="submitting"
                                       [disabled]="!form.signatures.guarantor?.downloadUrl"
                                       text="Submit"
                                       (onClick)="submit()"
                        ></loader-button>
                    </ng-container>
                    <button mat-flat-button color="primary" class="w-100" (click)="close()" *ngIf="form.signatures.guarantor?.submitted">Close</button>
                </div>
            </div>

        </div>
    </div>

</div>